import React, { useState, FC, useEffect } from "react";
import { Icon, TooltipComponent } from "../../components/Component";
import FormatDate from "../masters/DateFormater";

import { useNavigate } from "react-router";
import statusMapper from "./StatusMapper";

import DispatchAside from "./dispatchAside";
import { formatCurrency } from "../../utils/Utils";
import TransactionFlowDefaultTemplate from "../others/transactionFlowDefaultTemplate";
import { Button } from "reactstrap";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";

const ViewAllDispatch: FC = () => {
  const [sm, setSm] = useState(false);
  const navigate = useNavigate();
  const [siteOptions, setSiteOptions] = useState<any>([]);
  const { data: currentUser } = useSelector(
    (state: RootState) => state.currentUser
  );
  const columns: any = [
    {
      title: "Dispatch #",
      dataIndex: "dispatchId",
      key: "dispatchId",
      width: 300,
      fixed: "left",
      render: (text: any) => (
        <div className="align-left">
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Invoice #",
      dataIndex: "invoiceId",
      key: "invoiceId",
      width: 250,
      render: (text: any, record: any) => {
        if (!text && !record.invoiceNumber) return <span>-</span>;
        const invoiceId = text || record.invoiceId;
        const invoiceNumber = record.invoiceNumber;
        return (
          <span
            className="inlineTableCellLink"
            style={{ cursor: "pointer", color: "#2263b3" }}
            onClick={() => {
              if (invoiceNumber) {
                navigate(`/view-invoice/${invoiceNumber}`, {
                  state: { previousPath: "/view-dispatch-list" },
                });
              }
            }}
          >
            {invoiceId}
          </span>
        );
      },
    },
    {
      title: "Order #",
      dataIndex: "orderId",
      key: "orderId",
      width: 250,
      render: (text: any, record: any) => {
        if (!text && !record.orderNumber) return <span>-</span>;
        const orderId = text || record.orderId;
        const orderNumber = record.orderNumber;
        return (
          <span
            className="inlineTableCellLink"
            style={{ cursor: "pointer", color: "#2263b3" }}
            onClick={() => {
              if (orderNumber) {
                navigate(`/view-purchase-order/${orderNumber}`, {
                  state: { previousPath: "/view-dispatch-list" },
                });
              }
            }}
          >
            {orderId}
          </span>
        );
      },
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (date: any) => <span>{FormatDate(date)}</span>,
      width: 170,
    },
    {
      title: "Supplier",
      dataIndex: "supplierName",
      key: "supplierName",
      width: 250,
      render: (text: string, record: any, index: any) => {
        return (
          <>
            <span id={`supplierName-tooltip-${index}`}>
              {text?.length > 20 ? `${text?.substring(0, 25)}... ` : text}
            </span>
            {text?.length > 20 && (
              <TooltipComponent
                iconClass="info-circle text-info"
                icon="info"
                id={`supplierName-tooltip-${index}`}
                direction="top"
                text={text}
                containerClassName={""}
              />
            )}
          </>
        );
      },
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      width: 200,
    },
    {
      title: "Basic Amount",
      dataIndex: "basicAmount",
      key: "basicAmount",
      width: 200,
      render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          <span>{formatCurrency(text, record.currencyCode)}</span>
        </div>
      ),
    },

    {
      title: "SGST",
      dataIndex: "sgst",
      key: "sgst",
      width: 200,
      render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          <span>
            {Number(record?.sgst) && Number(record?.cgst)
              ? formatCurrency(text, record.currencyCode)
              : "N/A"}
          </span>
        </div>
      ),
    },
    {
      title: "CGST",
      dataIndex: "cgst",
      key: "cgst",
      width: 200,
      render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          <span>
            {Number(record?.sgst) && Number(record?.cgst)
              ? formatCurrency(text, record.currencyCode)
              : "N/A"}
          </span>
        </div>
      ),
    },
    {
      title: "IGST",
      dataIndex: "igst",
      key: "igst",
      width: 200,
      render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          <span>
            {!Number(record?.sgst) && !Number(record?.cgst)
              ? formatCurrency(text, record.currencyCode)
              : "N/A"}
          </span>
        </div>
      ),
    },

    {
      title: "Gross Total",
      dataIndex: "grossTotal",
      key: "grossTotal",
      width: 250,
      render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          <span>{formatCurrency(text, record.currencyCode)}</span>
        </div>
      ),
    },
    {
      title: "Created By",
      dataIndex: "createdUserName",
      key: "createdUserName",
      width: 200,
    },
    {
      title: "Status",
      dataIndex: "grnStatus",
      key: "grnStatus",
      width: 180,
      fixed: "right",
      render: (status: any) => {
        const _status = statusMapper[status]?.seller;
        return (
          <div className="justify-start align-center">
            <h6
              className={`tb-status ms-1`}
              style={{
                color: `${_status?.color}`,
                fontSize: "14px",
              }}
            >
              {_status?.icon} {_status?.title || status}
            </h6>
          </div>
        );
      },
    },

    {
      title: "Actions",
      key: "actions",
      fixed: "right",
      width: 80,
      render: (text: any, record: any) => (
        <>
          <Button
            size="sm"
            color=""
            onClick={() => {
              setSm(false);
              navigate(`/view-dispatch-details/${record.dispatchNumber}`, {
                state: { hideAside: true, previousPath: "/view-dispatch-list" },
              });
            }}
          >
            <Icon name="focus" />
          </Button>
        </>
      ),
    },
  ];

  useEffect(() => {
    if (currentUser) {
      const { siteAccessibility } = currentUser;
      if (siteAccessibility) {
        const options = currentUser.siteAccessibility.map((item: any) => ({
          label: item.siteName,
          value: item.siteID,
        }));
        setSiteOptions(options);
      }
    }
  }, [currentUser]);

  return (
    <TransactionFlowDefaultTemplate
      moduleKey="view-dispatch-list"
      title="Pending GRN's"
      columns={columns}
      sideNavigation={
        <div
          className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
            sm ? "content-active" : ""
          }`}
        >
          <DispatchAside updateSm={setSm} sm={sm} />
        </div>
      }
      selectFilters={[
        {
          title: "Site",
          placeholder: "Select Site",
          options: siteOptions,
          selectionMode: "multiple",
        },
      ]}
      extra={{
        tableScrollX: 1100,
        dateRange: true,
        dataFilterTootip: "Filtering based on Dispatch date",
      }}
    />
  );
};

export default ViewAllDispatch;
